module.exports = __webpack_public_path__ + "img/ZAR10021.0a08c46d.png";